module.exports = __webpack_public_path__ + "img/250299759_1892264114278976_2283485886262478192_n.fed624bc.jpg";